const TheContainer = () => import('@/containers/TheContainer')
const EmptyContainer = () => import('@/containers/EmptyContainer')
const TheContainerPrint = () => import('@/containers/TheContainerPrint')
const TheMainAsideBar = () => import('@/containers/TheMainAsideBar') //barra dir

const Campaign = () => import('./pages/Campaign')
const CampaignCreator = () => import('./pages/campaignCreator')
const CampaignSummary = () => import('./pages/CampaignSummary')
const CampaignList = () => import('./pages/CampaignList')
const CampaignResult = () => import('./pages/CampaignResult')

const CampaignResume = () => import('./pages/CampaignResume')

const ManageBalance = () => import('./pages/ManageBalance')

const Loading = () => import('./pages/Loading') //TODO mudar isso, apanas para mostrar componente

const campaignRoutes = [
  {
    path: 'campaign',
    component: TheContainer,
    children: [
      {
        path: '/',
        name: 'campaign',
        component: Campaign,
        meta: { requiresAuth: true },
      },
      {
        path: 'campaignCreator',
        name: 'campaignCreatorStart',
        component: CampaignCreator,
        meta: { requiresAuth: true },
      },
      {
        path: 'campaignCreator/:campaignId',
        component: TheMainAsideBar,
        meta: { requiresAuth: true },
        props: { default: true, AsidebarComponente: 'BlocksLibrary' },
        children: [
          {
            path: '',
            name: 'campaignCreator',
            component: CampaignCreator,
            meta: { requiresAuth: true },
          },
        ],
      },
      {
        path: 'campaignSummary/:campaignId',
        name: 'campaignSummary',
        component: CampaignSummary,
        meta: { requiresAuth: true },
      },
      {
        path: 'campaignResult/:campaignId',
        name: 'campaignResult',
        component: CampaignResult,
        meta: { requiresAuth: true },
      },
      {
        path: 'campaignResult/:campaignId/campaignResume/:scheduleType/:scheduleId/:type',
        name: 'campaignResume',
        component: CampaignResume,
        meta: { requiresAuth: true },
      },
      {
        path: 'campaignSend/:campaignId?',
        meta: { requiresAuth: true },
        name: 'campaignSend',
        component: CampaignCreator,
      },
      {
        path: 'campaignList',
        name: 'campaignList',
        component: CampaignList,
        meta: { requiresAuth: true },
      },
      {
        path: 'loading/:campaignId',
        name: 'campaignLoading',
        component: Loading,
        meta: { requiresAuth: true },
      },
      {
        path: '/manageBalance',
        name: 'manageBalance',
        component: ManageBalance,
        meta: { requiresAuth: true },
      },
    ],
  },
  // {
  //   path: '/campaign',
  //   component: TheContainerPrint,
  //   children: [
  //     {
  //       path: 'print/campaignResult/:campaignId',
  //       name: 'campaignResult',
  //       component: CampaignResult,
  //       props: { isPrint: true },
  //     },
  //   ],
  // },
]

export default campaignRoutes
